<div class="general-documents bg-white rounded-lg shadow-md border border-gray-200 p-6">
  <div class="flex justify-between items-center mb-6">
    <h3 class="text-xl font-semibold text-gray-900 flex items-center gap-2">
      <svg class="w-6 h-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
      </svg>
      Documentos Generales
    </h3>
    <button
      (click)="openCreateModal()"
      class="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition-colors duration-200 flex items-center gap-2">
      <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg>
      Nuevo Documento
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
  </div>

  <!-- Lista vacia -->
  <div *ngIf="!loading && documents.length === 0" class="text-center py-12">
    <svg class="mx-auto h-16 w-16 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
    </svg>
    <p class="mt-4 text-gray-500">No hay documentos subidos</p>
    <p class="text-sm text-gray-400">Haz clic en "Nuevo Documento" para agregar uno.</p>
  </div>

  <!-- Tabla de documentos -->
  <div *ngIf="!loading && documents.length > 0" class="overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo</th>
          <th class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha Subida</th>
          <th class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Expiracion</th>
          <th class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Verificado</th>
          <th class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Subido por</th>
          <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr *ngFor="let doc of documents" class="hover:bg-gray-50">
          <td class="px-4 py-4 whitespace-nowrap">
            <span class="text-sm font-medium text-gray-900">{{ doc.document_type_label }}</span>
          </td>
          <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
            {{ formatDate(doc.created_at) }}
          </td>
          <td class="px-4 py-4 whitespace-nowrap text-center">
            <span *ngIf="doc.expiration_date"
                  [class]="'inline-block px-2 py-1 rounded text-xs font-medium ' + getExpirationStatusClass(doc)">
              {{ formatDate(doc.expiration_date) }}
              <span *ngIf="doc.is_expired">(Caducado)</span>
              <span *ngIf="!doc.is_expired && doc.days_until_expiration !== null && doc.days_until_expiration <= 30">
                ({{ doc.days_until_expiration }}d)
              </span>
            </span>
            <span *ngIf="!doc.expiration_date" class="text-sm text-gray-400">-</span>
          </td>
          <td class="px-4 py-4 whitespace-nowrap text-center">
            <span class="inline-flex items-center gap-1 justify-center">
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs"
                [ngClass]="{
                  'bg-yellow-100 text-yellow-700': doc.status === 'pending',
                  'bg-green-100 text-green-700': doc.status === 'accepted',
                  'bg-red-100 text-red-700': doc.status === 'rejected'
                }">
                {{ doc.status_label || doc.status }}
              </span>
              <!-- Motivo del rechazo en tooltip -->
              <span *ngIf="doc.status === 'rejected' && doc.review_feedback"
                [pTooltip]="doc.review_feedback" tooltipPosition="top" [showDelay]="100"
                class="text-red-500 cursor-help">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </span>
            </span>
          </td>
          <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
            {{ doc.uploaded_by?.name || '-' }}
          </td>
          <td class="px-4 py-4 whitespace-nowrap text-right text-sm font-medium">
            <div class="flex justify-end gap-2">
              <!-- Ver/Descargar -->
              <button
                (click)="downloadDocument(doc)"
                class="text-blue-600 hover:text-blue-800 p-1"
                title="Descargar">
                <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </button>
              <!-- Editar -->
              <button
                (click)="openEditModal(doc)"
                class="text-yellow-600 hover:text-yellow-800 p-1"
                title="Editar">
                <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </button>
              <!-- Aceptar -->
              <button
                *ngIf="doc.status !== 'accepted'"
                (click)="verifyDocument(doc)"
                class="text-green-600 hover:text-green-800 p-1"
                title="Aceptar">
                <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </button>
              <!-- Rechazar -->
              <button
                *ngIf="doc.status !== 'rejected'"
                (click)="rejectDocument(doc)"
                class="text-orange-600 hover:text-orange-800 p-1"
                title="Rechazar">
                <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </button>
              <!-- Eliminar -->
              <button
                (click)="deleteDocument(doc)"
                [disabled]="deleting"
                class="text-red-600 hover:text-red-800 p-1 disabled:opacity-50"
                title="Eliminar">
                <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-reject-reason-modal
  [visible]="!!rejectingDoc"
  title="Rechazar documento"
  (confirm)="confirmReject($event)"
  (cancel)="rejectingDoc = null">
</app-reject-reason-modal>
